import { Button } from "design-system/atoms/Button"
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useImportCustomersMutation } from "modules/customers/hooks/useImportCustomersMutation"
import { FieldValues, UseFormReturn } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { ImportCustomersResponseData } from "schema"
import { z } from "zod"
import { ImportFileField } from "./ImportFileField"

type Props = {
  fileForm: UseFormReturn<FieldValues>
  onClose: () => void
  onActionResponse: (response: z.infer<typeof ImportCustomersResponseData>) => void
}

export function ImportUpload({ fileForm, onClose, onActionResponse }: Props) {
  const { t } = useTranslation()

  const { mutateAsync: uploadCustomersImport, isPending: isUploading } = useImportCustomersMutation(
    {
      onSuccess: onActionResponse,
    },
  )

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t("customers.imports.upload.title")}</DialogTitle>
        <DialogDescription>{t("customers.imports.upload.description")}</DialogDescription>
      </DialogHeader>
      <ImportFileField fileForm={fileForm} />
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>
          {t("shared.cancel")}
        </Button>
        <Button
          onClick={() =>
            uploadCustomersImport({
              preview: "true",
              file: fileForm.watch("file"),
            })
          }
          disabled={isUploading || !fileForm.watch("file")?.length}
        >
          {t("customers.imports.upload.upload")}
        </Button>
      </DialogFooter>
    </>
  )
}
